import React from 'react';
import loadable from '@loadable/component';
import type { AppWidgetProps } from '../../../types/common';

const DefaultWidget = loadable(() => import('./Widget'));
const PlanListPageWidget = loadable(() => import('./PlanListPageWidget'));

const Widget: React.FC<AppWidgetProps> = (props) => {
  return props.isMultiPageApp ? <PlanListPageWidget {...props} /> : <DefaultWidget {...props} />;
};

export default Widget;
